import { Link, useNavigate } from 'react-router-dom'
// import { useEffect, useRef } from 'react'
import Avatar from 'react-avatar'
import { useUser } from '../UserContext'
import { useSidebar } from '../utils/SidebarContext'
import stringShortner from '../utils/stringShortner'
import BannerAd from '../Advertisement/BannerAd'
import { AAds } from '../Advertisement/AdConfig'
import './Sidebar.css'

export default function Sidebar() {
  const { user } = useUser()
  let navigate = useNavigate()
  const { isSidebarOpen, toggleSidebar } = useSidebar()

  const userPicture = user.picture
  const displayName = user.displayName

  const sendEmailOTP = () => {
    navigate('/email-verification', {
      replace: true,
      state: { email: user.email, sendOTP: true },
    })
  }

  const sidebarLinks = [
    {
      id: 'DashboardBtn',
      path: '/dashboard',
      icon: 'bi bi-grid-1x2',
      label: 'Dashboard',
    },
    {
      id: 'LeaderBoardBtn',
      path: '/global-leader-board',
      icon: 'bi bi-trophy',
      label: 'Leaderboard',
    },
    {
      id: 'GameRoomsBtn',
      path: '/game-rooms',
      icon: 'bi bi-hdd-stack',
      label: 'Game Rooms',
    },
    {
      id: 'JoinedGames',
      path: '/joined-games',
      icon: 'bi bi-person-plus',
      label: 'Joined Games',
    },
    {
      id: 'FixtureBtn',
      path: '/fixtures',
      icon: 'bi bi-calendar',
      label: 'Fixtures',
    },
    {
      id: 'WalletBtn',
      path: '/Wallet',
      icon: 'bi bi-wallet2',
      label: 'Wallet',
    },
    {
      id: 'ReferBtn',
      path: '/refer',
      icon: 'bi bi-person-add',
      label: 'Refer',
    },
    {
      id: 'LogoutBtn',
      path: '/logout',
      icon: 'bi bi-box-arrow-right',
      label: 'Logout',
    },
    // {
    //   id: 'MyTeams',
    //   path: '/my-teams',
    //   icon: 'bi bi-people',
    //   label: 'My Lineups',
    // },
  ]

  return (
    <>
      {isSidebarOpen && (
        <div className='bgOverlay' onClick={toggleSidebar}></div>
      )}
      <div className={`sidebar ${isSidebarOpen ? 'show' : ''}`}>
        {isSidebarOpen && (
          <div className='sidebarMobCloseBtn'>
            <i className=' bi bi-x' onClick={toggleSidebar}></i>
          </div>
        )}
        <div>
          <div className='sidebarProfileSection'>
            {userPicture ? (
              <div
                className='dpImg '
                style={{ backgroundImage: `url(${userPicture})` }}
              ></div>
            ) : (
              <Avatar
                name={displayName}
                size='50'
                className='userdp dpImg'
                textSizeRatio={2}
              />
            )}

            <div style={{ textAlign: 'left' }}>
              <h4 className='oneLineText3dot'>
                {stringShortner(displayName, 10)}
              </h4>
              <Link to='/profile' className='profileBtn'>
                Profile
                {/* <i className='bi bi-pencil' style={{ fontSize: '0.9rem' }}></i> */}
              </Link>
            </div>
          </div>

          {!user.hasVerifiedEmail && (
            <div onClick={sendEmailOTP}>
              <div className='sidebarBtn shine btn'>
                <i className='bi bi-exclamation-triangle'></i> Verify Email
              </div>
            </div>
          )}

          <div className='sidebarLinksContainer'>
            {sidebarLinks.map(({ id, path, icon, label }) => {
              const isActive = location.pathname.startsWith(path) // Check if active

              return (
                <Link key={id} to={path}>
                  <div
                    id={id}
                    className={`sidebarBtn shine ${isActive ? 'active' : ''}`}
                  >
                    <i className={icon}></i> {label}
                  </div>
                </Link>
              )
            })}
          </div>
        </div>
        <div className='bottom'>
          <BannerAd AdUnitId={AAds.SidebarAdUnitId} />
          <p>Follow Us </p>
          <div className='followbtn' style={{ marginBottom: '20px' }}>
            <a
              href='https://t.me/ThefanclubpanenkaFC'
              target='_blank'
              rel='noopener noreferrer'
            >
              <i className='bi bi-telegram'></i>
            </a>
            <a
              href='https://www.linkedin.com/company/panenkafc/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <i className='bi bi-linkedin'></i>
            </a>
            <a
              href='https://twitter.com/PanenkaFC90'
              target='_blank'
              rel='noopener noreferrer'
            >
              <i className='bi bi-twitter-x'></i>
            </a>
          </div>
          {/* <img className="SidebarLogo" src={Logo} alt="logo" /> */}
        </div>
      </div>
    </>
  )
}
